import { ref } from '@vue/composition-api';
import { PaginationResponse } from '@/bundles/App/type';
import { IPaginationDto } from '@/bundles/App/interfaces';
import { physicalExerciseService } from '@/bundles/VideoContent/factory/physicalExerciseServiceFactory';

interface IExerciseDto {
  name: string;
  description: string;
  thumbnail?: File;
  video: string;
  duration: number;
  file?: any;
  instructor?: string;
}

export function usePhysicalExercise() {
  const exercises = ref<any[]>([]);
  const total = ref<number>(0);
  const loading = ref<boolean>(false);
  const error = ref<Error | null>(null);

  const fetchExercises = async (params: IPaginationDto): Promise<void> => {
    loading.value = true;
    error.value = null;

    try {
      const response: PaginationResponse<any> = await physicalExerciseService.getList(params);
      exercises.value = response.data;
      total.value = response.total;
    } catch (e) {
      throw e;
    } finally {
      loading.value = false;
    }
  };

  const convertToFormData = (exercise: IExerciseDto): FormData => {
    const formData = new FormData();
    formData.append('name', exercise.name);
    formData.append('description', exercise.description);
    formData.append('video', exercise.video);
    formData.append('duration', exercise.duration as unknown as string);
    formData.append('instructor', exercise.instructor as unknown as string);
    if (exercise.file) {
      formData.append('thumbnail', exercise.file!);
    }
    return formData;
  };

  const createExercise = async (exercise: IExerciseDto): Promise<void> => {
    loading.value = true;
    error.value = null;

    try {
      const formData = convertToFormData(exercise);
      await physicalExerciseService.createExercise(formData);
    } catch (e) {
      error.value = e;
      throw e;
    } finally {
      loading.value = false;
    }
  };


  const updateExercise = async (id: number, exercise: IExerciseDto): Promise<void> => {
    loading.value = true;
    error.value = null;

    try {
      const formData = convertToFormData(exercise);
      await physicalExerciseService.updateExercise(id, formData);
    } catch (e) {
      error.value = e;
      throw e;
    } finally {
      loading.value = false;
    }
  };

  return {
    exercises,
    total,
    loading,
    error,
    fetchExercises,
    createExercise,
    updateExercise,
    convertToFormData,
  };
}
